<!-- Toast Notifications Container -->
<div class="fixed top-4 right-4 z-50 space-y-4 max-w-md">
  @for (toast of toasts(); track toast) {
    <div
      class="bg-white dark:bg-gray-800 rounded-lg shadow-lg border-l-4 p-4 transform transition-all duration-300 ease-in-out animate-slide-in"
      [class.border-green-500]="toast.type === 'success'"
      [class.border-red-500]="toast.type === 'error'"
      [class.border-yellow-500]="toast.type === 'warning'"
      [class.border-blue-500]="toast.type === 'info'">
      <div class="flex items-start gap-3">
        <!-- Icon -->
        <div class="flex-shrink-0 mt-0.5">
          @if (toast.type === 'success') {
            <i class="fas fa-check-circle text-green-500 text-xl"></i>
          }
          @if (toast.type === 'error') {
            <i class="fas fa-times-circle text-red-500 text-xl"></i>
          }
          @if (toast.type === 'warning') {
            <i class="fas fa-exclamation-triangle text-yellow-500 text-xl"></i>
          }
          @if (toast.type === 'info') {
            <i class="fas fa-info-circle text-blue-500 text-xl"></i>
          }
        </div>
        <!-- Content -->
        <div class="flex-1 min-w-0">
          <h4 class="text-sm font-semibold text-gray-900 dark:text-white mb-1">
            {{ toast.title }}
          </h4>
          <p class="text-sm text-gray-600 dark:text-gray-300 break-words">
            {{ toast.message }}
          </p>
        </div>
        <!-- Close Button -->
        <button
          type="button"
          (click)="onDismiss(toast.id)"
          class="flex-shrink-0 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  }
</div>
